import { render, staticRenderFns } from "./myService.vue?vue&type=template&id=6c436d41&scoped=true"
import script from "./myService.vue?vue&type=script&lang=js"
export * from "./myService.vue?vue&type=script&lang=js"
import style0 from "./myService.vue?vue&type=style&index=0&id=6c436d41&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c436d41",
  null
  
)

export default component.exports